@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use 'sass:color' as sassColor;

$hover-shadow-primary: sassColor.adjust($color-primary-purple, $alpha: -0.8);
$hover-shadow-error: sassColor.adjust($color-primary-red, $alpha: -0.8);

.InputPassword {
  .Layout {
    @extend %form-control-border;
    @extend %form-control-background;

    display: flex;
    gap: 4px;
    align-items: center;
    padding: 0 12px 0 16px;
    box-sizing: border-box;
    overflow: hidden;

    &:hover {
      box-shadow: 0 0 0 3px $hover-shadow-primary;
    }

    &:focus-within {
      border-color: $color-primary-purple;
      box-shadow: 0 0 0 3px $hover-shadow-primary;
    }

    &.Disabled {
      background-color: $theme-color-sub-background;
      color: $theme-color-readonly-field-text;

      input::placeholder {
        color: $theme-color-text;
      }

      &:hover,
      &:focus,
      &:focus-within {
        box-shadow: none;
      }
    }
  }

  input {
    @extend %form-control-font;

    flex-grow: 1;
    border: none;
    outline: none;
    padding: 0;
    height: $component-height;
    box-sizing: border-box;
    appearance: none;
    width: 100%;
    background-color: transparent;

    &[disabled] {
      cursor: not-allowed;
      pointer-events: none;
      color: $theme-color-readonly-field-text;

      ::placeholder {
        color: $theme-color-text;
      }
    }
  }
}
